import { useCallback } from 'react'
import { collection, serverTimestamp } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { addDoc } from '../lib/firestore'
import { track } from '../lib/analytics'
import type { Report } from '../types'

export type ReportInput = Pick<Report, 'reportedUserId' | 'contentType' | 'contentId' | 'reason' | 'message'>

/** Files a user report. Rules require a non-anonymous reporter — guard the entry point. Throws on failure. */
export function useSubmitReport(reporterId: string | null) {
  return useCallback(
    async ({ reportedUserId, contentType, contentId, reason, message }: ReportInput) => {
      if (!reporterId) return
      await addDoc(collection(db, 'reports'), {
        reporterId,
        reportedUserId,
        contentType,
        ...(contentId ? { contentId } : {}),
        reason,
        ...(message?.trim() ? { message: message.trim() } : {}),
        status: 'pending',
        type: 'user',
        createdAt: serverTimestamp(),
      })
      track('content_reported', { content_type: contentType, reason })
    },
    [reporterId],
  )
}
